import { useAppDispatch } from 'hooks';
import React, { FormEvent, useId, useState } from 'react';
import styles from './styles.module.sass';
import { InputLabel, Input } from '@mui/material';
import { patientsActions } from 'utils/store';
import { Button } from 'components';
import { ButtonType } from 'types/enums';

export const ConnectNewPatient = () => {
  const dispatch = useAppDispatch();
  const [inputValue, setInputValue] = useState('');

  const onEmailAddClick = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    dispatch(patientsActions.connectPatientAndCaregiverConnectionByEmail(inputValue));
    setInputValue('');
  };

  const id = useId();

  return (
    <div className={styles.container}>
      <h4>Connect new patient:</h4>
      <form className={styles.form} onSubmit={onEmailAddClick}>
        <InputLabel htmlFor={id}>Patient email:</InputLabel>
        <Input
          type='email'
          className={styles.input}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          id={id}
        ></Input>
        <div>
          <Button type='submit' disabled={!inputValue} buttonType={ButtonType.SECONDARY}>
            Add
          </Button>
        </div>
      </form>
    </div>
  );
};
